import React from 'react';
import { Button, ProgressCircle } from '@adobe/react-spectrum';
import { withTheme } from '../../ThemeProvider';
import style from './PrimaryActionButton.module.less';
import cn from 'classnames';

/**
 * @type {React.FC<import('@react-types/button').SpectrumActionButtonProps & { loading: boolean; onClick?: (e: Event) => void; style?: any }>}
 */
const PrimaryActionButton = ({ children, onClick, ...props }) => {
  return (
    <Button
      {...props}
      UNSAFE_className={cn(style.button, props?.UNSAFE_className)}
      UNSAFE_style={{ ...props.style }}
      type={props?.type}
      onPress={onClick ?? props.onPress} // Prefer onClick as onPress breaks convention
      variant="cta"
    >
      {children}
      {props.loading && <ProgressCircle isIndeterminate size="S" marginStart="5px" variant="overBackground" />}
    </Button>
  );
};

PrimaryActionButton.displayName = 'PrimaryActionButton';

export default withTheme(PrimaryActionButton);
